import { useNavigate, useLocation } from "react-router-dom";
import { Bell } from "lucide-react";
import { useSelector } from "react-redux";
import { selectUnreadCount } from "@/redux/slices/notificationsSlice";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface NotificationBadgeProps {
  className?: string;
}

export function NotificationBadge({ className }: NotificationBadgeProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const unreadCount = useSelector(selectUnreadCount);
  const isOnNotificationsPage = location.pathname === "/notifications";

  const handleClick = () => {
    navigate("/notifications");
  };

  if (isOnNotificationsPage) return null;

  return (
    <button
      type="button"
      onClick={handleClick}
      className={cn(
        "relative w-10 h-10 flex items-center justify-center rounded-full bg-background/80 backdrop-blur-sm border border-border hover:bg-muted transition-colors duration-200",
        className
      )}
      aria-label={
        unreadCount > 0
          ? `Notifications (${unreadCount} unread)`
          : "Notifications"
      }
    >
      <Bell className="w-4 h-4 text-foreground" />
      {unreadCount > 0 && (
        <Badge
          variant="destructive"
          className="absolute -top-0.5 -right-0.5 min-w-[1.25rem] h-5 px-1 flex items-center justify-center text-xs"
        >
          {unreadCount > 99 ? "99+" : unreadCount}
        </Badge>
      )}
    </button>
  );
}
